
import React from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Card, CardActionArea, CardContent, Grid, Paper, Typography } from "@mui/material";
import { iconos } from "../../../../data/iconos-data";





export const CardDetalles = ({ item }) => {

    
    const navigate = useNavigate();



    const handleIrOpcion = (url) => {
        navigate(url);
    }


    return (

        <Grid item xs={12} sm={6} md={4}>
            <Paper elevation={3} sx={{borderRadius:2, transition: 'transform 0.3s, box-shadow 0.3s',
                '&:hover': {transform:'translateY(-5px)', boxShadow:10}
            }}>
                <Card sx={{width:'100%', height:150, borderRadius:2, overflow:'visible'}}>
                    <CardActionArea sx={{ width:'100%', height:'100%', display:'flex', alignItems:'center',padding:2}}
                        onClick={ () => item.route && handleIrOpcion(item.route) }
                    >
                        <Avatar sx={{ width:56, height:56, backgroundColor:item.color, boxShadow: 3,marginRight: 2}}>
                            {iconos[item.icon] && React.isValidElement(iconos[item.icon]) 
                            ? React.cloneElement(iconos[item.icon], { style: { fontSize: 28, color: 'white' } }) 
                            : null}
                        </Avatar>

                        <CardContent sx={{ flex:1, padding:'16px 8px' }}>
                            <Typography variant="h6" sx={{fontWeight: 600, mb: 0.7, lineHeight: 1.1}}>
                                {item.title}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{lineHeight: 1.1}}>
                                {item.description}
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Paper>
        </Grid>


    )
}
